import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { CMA_SUPPORT_URL } from '../apiConfig'

export const fetchDefaultResolution = createAsyncThunk(
  'fetchDefaultResolution',
  async ({ jwtBearer, category_id }) => {
    const response = await fetch(`${CMA_SUPPORT_URL}get/default/ticket/resolution/?category_id=${category_id}`, {
      headers: {
        Authorization: `Bearer ${jwtBearer}` // Include the bearer token in the request header
      }
    })
    return response.json()
  }
)

const DefaultResolutionSlice = createSlice({
  name: 'DefaultResolutionSlice',
  initialState: {
    isLoading: false,
    data: null,
    isError: false
  },
  extraReducers: builder => {
    builder.addCase(fetchDefaultResolution.pending, (state, action) => {
      state.isLoading = true
    })
    builder.addCase(fetchDefaultResolution.fulfilled, (state, action) => {
      state.isLoading = false
      state.data = action.payload
    })
    builder.addCase(fetchDefaultResolution.rejected, (state, action) => {
      console.log('Error', action.payload)
      state.isError = true
    })
  }
})

export default DefaultResolutionSlice.reducer
